import { Component, HostListener, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './_api/auth.service';
import { ThemeService } from './shared/services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
})
export class AppComponent {
  private auth = inject(AuthService);
  private theme = inject(ThemeService);

  title = 'ERP';

  readonly impersonation = this.auth.impersonation;

  stopImpersonating(): void {
    this.auth.stopImpersonating();
  }

  @HostListener('document:click', ['$event'])
  openDatepickerFromField(event: MouseEvent): void {
    const input = (
      event.target as HTMLElement | null
    )?.closest<HTMLInputElement>(
      'input.mat-datepicker-input, input.mat-date-range-input-inner',
    );
    if (!input || input.disabled) {
      return;
    }
    input
      .closest('.mat-mdc-form-field')
      ?.querySelector<HTMLButtonElement>(
        '.mat-datepicker-toggle button:not([disabled])',
      )
      ?.click();
  }
}
